/**
 * A CMS-set CTA aria label, as authored with surrounding spaces trimmed. Blank
 * or non-string reads as unset, so the button is named by its visible wording.
 * CI owns the wording's accuracy (WCAG 2.5.3 Label in Name is an authoring
 * responsibility).
 */
export function ctaAriaLabel(asked: unknown): string | undefined {
  const name = typeof asked === "string" ? asked.trim() : "";
  return name === "" ? undefined : name;
}
